import { css } from "lit";

/**
 * Shared styles for rendering a list of sent chat attachments inside a message
 * bubble. Consumed by community-chat and live-chat. The paperclip/chip UI inside
 * the input itself is in `chat-message-input.css.ts`.
 */
export const chatAttachmentStyles = css`
  .attachments {
    list-style: none;
    margin: var(--sds-size-space-200) 0 0 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-150);
  }

  /* Non-previewable files (and failed previews) render as a download bubble. */
  .attachment-file {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-200);
    padding: var(--sds-size-space-200) var(--sds-size-space-400);
    background: var(--sds-color-background-default-secondary);
    border: 1px solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-600);
    color: var(--sds-color-text-default-default);
    text-decoration: none;
    max-width: 320px;
  }

  .attachment-file:hover {
    background: var(--sds-color-background-default-tertiary);
  }

  .attachment-file-row {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-400);
    width: 100%;
  }

  .attachment-file-icon {
    flex-shrink: 0;
  }

  .attachment-file-name {
    flex: 1;
    min-width: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-family: var(--sds-typography-family-title);
    font-size: 14px;
    line-height: 1.2;
    color: var(--sds-color-text-default-default);
  }

  .attachment-file-download {
    flex-shrink: 0;
    color: var(--sds-color-icon-default-default);
  }

  .attachment-file-meta {
    align-self: flex-end;
    font-family: var(--sds-typography-family-body);
    font-size: 10px;
    line-height: 1;
    color: var(--sds-color-text-default-tertiary);
  }

  /* Image attachments render inline instead of as a download link. */
  .attachment-image-link {
    display: block;
    width: fit-content;
    max-width: 100%;
    line-height: 0;
  }

  .attachment-image,
  .attachment-video {
    display: block;
    max-width: 100%;
    max-height: 240px;
    width: auto;
    height: auto;
    border-radius: var(--sds-size-radius-600);
    background: var(--sds-color-background-default-secondary);
  }
`;
